if (!customElements.get('video-expand')) {
  customElements.define(
    'video-expand',
    class VideoExpand extends HTMLElement {
      connectedCallback() {
        this.ticking = false;
        this.onScroll = this.requestUpdate.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      requestUpdate() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        const parent = this.parentElement;
        const parentStyle = getComputedStyle(parent);
        const parentRect = parent.getBoundingClientRect();
        const paddingLeft = parseFloat(parentStyle.paddingLeft) || 0;
        const paddingRight = parseFloat(parentStyle.paddingRight) || 0;

        // Resting (contained) geometry of the video, before expansion.
        const baseLeft = parentRect.left + paddingLeft;
        const baseWidth = parentRect.width - paddingLeft - paddingRight;
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight;

        // 0 when the video's top enters the bottom of the viewport,
        // 1 once its top has scrolled up to the configured end point.
        const top = this.getBoundingClientRect().top;
        const endRatio = parseFloat(this.dataset.expandEnd);
        const end = viewportHeight * (Number.isNaN(endRatio) ? 0.2 : endRatio);
        const progress = Math.min(1, Math.max(0, (viewportHeight - top) / (viewportHeight - end)));

        // Starting size is a fraction of the contained width, centered within it.
        const startRatio = parseFloat(this.dataset.expandStart);
        const startWidth = baseWidth * (Number.isNaN(startRatio) ? 1 : startRatio);
        const startOffset = (baseWidth - startWidth) / 2;

        const lerp = (from, to) => from + (to - from) * progress;

        this.style.setProperty('--expand-progress', progress);
        this.style.width = `${lerp(startWidth, viewportWidth)}px`;
        this.style.marginLeft = `${lerp(startOffset, -baseLeft)}px`;
      }
    }
  );
}
